import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

import App from './App';
import './index.css';

// DNOTE:
// For deployment staging | production use the following commented code.
/*
const middleware = applyMiddleware(thunk);
ReactDOM.render(
  <Provider store={createStore(reducers, middleware)}>
    <App />
  </Provider>, document.getElementById('root'));
*/

// For connecting Redux dev tools
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-disable */
const composeEnhancers = 
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) 
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true, // Enable tracing
        traceLimit: 25 // Set a limit to the number of stack trace entries
      }) 
    : compose;
/* eslint-enable */
ReactDOM.render(
  <Provider store={createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk)))
  }>
    <App />
  </Provider>, document.getElementById('root'));
